import { LOGIN, REQ_USER, INSERT_AUDITSTAMPING, UPDATE_AUDITSTAMPING, AUDITSTAMPING_LIST } from "./ActionType";

const initialValue = {
  signin: null,
  reqUser: null,
  insertAudtiStamping: [],
  updateAudtiStamping: [],
  auditList: [],
};

export const authReducer = (store = initialValue, { type, payload }) => {
  if (type === LOGIN) {
    return { ...store, signin: payload };
  } else if (type === REQ_USER) {
    return { ...store, reqUser: payload };
  } else if (type === INSERT_AUDITSTAMPING) {
    return {
      ...store,
      insertAudtiStamping: payload
    };
  }else if (type === UPDATE_AUDITSTAMPING) {
    return {
      ...store,
      updateAudtiStamping: payload
    };
  }else if (type === AUDITSTAMPING_LIST) {
    return {
      ...store,
      auditList: payload
    };
  }

  return store;
};
